import { RouteRecordRaw } from 'vue-router';

const INTERNAL_JOB_FUNCTION_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'InternalJobFunctionsOverview',
      component: () => import('@/modules/internal-job-functions/pages/InternalJobFunctionsOverview.vue'),
   },
];

export default INTERNAL_JOB_FUNCTION_ROUTES;
